export default __webpack_public_path__ + "static/media/Indiana.10098bc4.jpg";